export const normalizePhone = (value) => {
    let phone = String(value || '').replace(/\D/g, '');

    if (phone.startsWith('0034')) {
        phone = phone.slice(4);
    } else if (phone.startsWith('34') && phone.length === 11) {
        phone = phone.slice(2);
    }

    return phone;
};

export const isSpanishMobilePhone = (value) => /^[6-9]\d{8}$/.test(normalizePhone(value));